/**
 * live-streaming-by-broadcaster-group-1-week
 *
 * @author    Andy Lowe <andy.lowe@mediatel.co.uk>
 * @copyright 2019 Mediatel Limited.
 */

"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules:
import weeklyPeriodSelectsFactory from "./tv-player-report/weekly-period-selects-open";
import broadcastersSelectFactory from "./tv-player-report/broadcasters-select";
import liveStreamingReport from "./tv-player-report/live-streaming-open";
import moreInfo from "./top-programmes/more-info";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule(
    "period_selects",
    weeklyPeriodSelectsFactory("tv-player-report/get-live-streaming-by-channel-available-weeks", {
        limitPeriod: '201605060115'
    })
);
core.createModule("broadcasters_select", broadcastersSelectFactory("live_streaming_by_channel"));
core.createModule(
    "live_streaming_channels",
    liveStreamingReport(
        "tv-player-report/live-streaming-by-broadcaster-group",
        {
            labelTableName: 'Broadcaster group',
            csvName: 'Live-streaming-broadcasters.csv'
        }
    )
);

core.createModule("moreInfo", moreInfo);

core.startAll();